// import React from 'react'
// import { Button } from '@material-ui/core'
// import {
// 	FirstPage as FirstPageIcon,
// 	LastPage as LastPageIcon,
// 	ChevronLeft as ChevronLeftIcon,
// 	ChevronRight as ChevronRightIcon
// } from '@material-ui/icons'

// export function DataTablePagination({
// 	page,
// 	totalPages,
// 	limit,
// 	onPageChange,
// 	onPageSizeChange,
// 	totalRecords
// }) {
// 	return (
// 		<div
// 			style={{
// 				display: 'flex',
// 				alignItems: 'center',
// 				justifyContent: 'space-between',
// 				gap: '8px'
// 			}}
// 		>
// 			<div style={{ flex: 1, fontSize: '14px' }}>Total: {totalRecords} Item(s)</div>
// 			<div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
// 				{/* <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
// 					<p style={{ fontSize: '14px', fontWeight: 'bold' }}>Items per page</p>
// 					<FormControl variant="outlined" size="small">
// 						<Select
// 							value={limit}
// 							onChange={e => onPageSizeChange(Number(e.target.value))}
// 							style={{ height: '32px', width: '70px' }}
// 						>
// 							{[10, 20, 30, 40, 50].map(pageSize => (
// 								<MenuItem key={pageSize} value={pageSize}>
// 									{pageSize}
// 								</MenuItem>
// 							))}
// 						</Select>
// 					</FormControl>
// 				</div> */}
// 				<div
// 					style={{
// 						fontSize: '14px',
// 						fontWeight: 'bold',
// 						textAlign: 'center',
// 						width: '100px'
// 					}}
// 				>
// 					Page {page} of {totalPages}
// 				</div>
// 				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
// 					<Button
// 						variant="outlined"
// 						style={{ height: '32px', width: '32px', padding: '0' }}
// 						onClick={() => onPageChange(page - 1)}
// 						disabled={page <= 1}
// 					>
// 						<ChevronLeftIcon fontSize="small" />
// 					</Button>
// 					<Button
// 						variant="outlined"
// 						style={{ height: '32px', width: '32px', padding: '0' }}
// 						onClick={() => onPageChange(page + 1)}
// 						disabled={page >= totalPages}
// 					>
// 						<ChevronRightIcon fontSize="small" />
// 					</Button>
// 				</div>
// 			</div>
// 		</div>
// 	)
// }

import React from 'react'
import { Button, FormControl, MenuItem, Select } from '@material-ui/core'
import {
	FirstPage as FirstPageIcon,
	LastPage as LastPageIcon,
	ChevronLeft as ChevronLeftIcon,
	ChevronRight as ChevronRightIcon,
	SearchOutlined
} from '@material-ui/icons'

export function DataTablePagination({
	page,
	totalPages,
	limit,
	onPageChange,
	onPageSizeChange,
	totalRecords
	// searchQuery,
	// setSearchQuery
}) {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				gap: '8px'
			}}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: '16px'
				}}
			>
				<div style={{ flex: 1, fontSize: '14px' }}>Total: {totalRecords} Item(s)</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<p style={{ fontSize: '14px', fontWeight: 'bold' }}>Items per page</p>
					<FormControl variant="outlined" size="small">
						<Select
							value={limit}
							onChange={event => onPageSizeChange(Number(event.target.value))}
							style={{ height: '32px', width: '70px' }}
						>
							{[10, 20, 30, 40, 50].map(pageSize => (
								<MenuItem key={pageSize} value={pageSize}>
									{pageSize}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</div>
				<div
					style={{
						fontSize: '14px',
						fontWeight: 'bold',
						textAlign: 'center',
						width: '100px'
					}}
				>
					Page {page} of {totalPages}
				</div>

				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<Button
						variant="outlined"
						style={{ height: '32px', width: '32px', padding: '0' }}
						onClick={() => onPageChange(page - 1)}
						disabled={page <= 1}
					>
						<ChevronLeftIcon fontSize="small" />
					</Button>
					<Button
						variant="outlined"
						style={{ height: '32px', width: '32px', padding: '0' }}
						onClick={() => onPageChange(page + 1)}
						disabled={page >= totalPages}
					>
						<ChevronRightIcon fontSize="small" />
					</Button>
				</div>
			</div>
		</div>
	)
}
